<ng-container *ngIf="document else loading">
	<div class="card-portal">
		<div class="card-header">
			<div class="card-header-right">
				<mat-icon svgIcon="icon_certificate" class="header-margin-right"></mat-icon>
				<div>{{document.typeDescription ? document.typeDescription :
					UNDERSCORE}}</div>
			</div>
			<div>
				<div class="card-header-label" translate>commercial-documents.certificate-number</div>
				<a class="card-header-value"
					[routerLink]="['/commercial-documents/cards/certificate-card', document.id]">
					{{ document.name ? document.name : UNDERSCORE }}
				</a>
			</div>
			<div>
				<div class="card-header-label" translate>commercial-documents.certificate-type</div>
				<div>{{ document.subtypeDescription ? document.subtypeDescription : UNDERSCORE }}</div>
			</div>
			<div class="card-header-right card-header-double-span">
				<mat-icon svgIcon="calendar" class="header-margin-right"></mat-icon>
				<div class="card-container-column">
					<span class="card-header-label" translate>datacenter-filter.creation-date</span>
					<span>{{ (document.date ? document.date : UNDERSCORE) | copoDate:'date' }}</span>
				</div>
			</div>
			<div class="card-container-link">
				<a mat-icon-button [href]="getDocumentURL(document.id, document.name) | copoSafeUrl" target="_blank"
					type="application/pdf" class="icon-color" [title]="'quapp.action.view' | translate">
					<mat-icon svgIcon="md:eye"></mat-icon>
				</a>
				<a mat-icon-button [href]="downloadDocument(document.id, document.name) | copoSafeUrl" target="_blank"
					type="application/pdf" class="icon-color" [title]="'sb.Download' | translate">
					<mat-icon svgIcon="md:download"></mat-icon>
				</a>
			</div>
		</div>
		<div class="card-content">
			<div class="card-header-tripple-span card-container-column">
				<div class="card-container-row">
					<div class="card-content-label" translate>commercial-documents.customer-order-number</div>
					<div class="card-content-label" translate>commercial-documents.supplier-order-number</div>
					<div class="card-content-label" translate>order.steelgrade</div>
				</div>
				<div *ngFor="let docLine of document.documentLines; let i = index">
					<div class="card-container-row" *ngIf="i < 3">
						<div>
							{{getOrderName(docLine, 'customer')}}
						</div>
						<div>
							{{getOrderName(docLine, 'supplier')}}
						</div>
						<div class="order-weight-label">
							{{ docLine.steelGrade ? docLine.steelGrade : UNDERSCORE}}
						</div>
					</div>
				</div>
			</div>
			<div class="card-header-double-span">
				<div class="card-content-label" translate>commercial-documents.mill</div>
				<div>{{ document.millDescription ? document.millDescription : UNDERSCORE }}</div>
			</div>
			<div class="card-container-column card-column-end" *ngIf="document.documentLines.length > 3">
				<a mat-button color="primary" (click)="callFilter(document, 'batch')"
					[routerLink]="['/order-tracking/batch/list']">
					<span translate>order.card.document.display.batches</span>
					<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
				</a>
				<a mat-button color="primary" (click)="callFilter(document, 'order')"
					[routerLink]="['/order-tracking/order/list']">
					<span translate>commercial-documents.display-all-orders</span>
					<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
				</a>
			</div>
		</div>
	</div>
	<div class="card-mobile">
		<div class="card-header">
			<div class="card-header-left">
				<mat-icon svgIcon="icon_certificate" class="header-margin-right"></mat-icon>
				<span class="header-margin-right overflow-wrap">{{document.typeDescription ? document.typeDescription :
					UNDERSCORE}}</span>
			</div>
			<div class="card-container-link">
				<a mat-icon-button [href]="getDocumentURL(document.id, document.name) | copoSafeUrl" target="_blank"
					type="application/pdf" class="icon-color" [title]="'quapp.action.view' | translate">
					<mat-icon svgIcon="md:eye"></mat-icon>
				</a>
				<a mat-icon-button [href]="downloadDocument(document.id, document.name) | copoSafeUrl" target="_blank"
					type="application/pdf" class="icon-color" [title]="'sb.Download' | translate">
					<mat-icon svgIcon="md:download"></mat-icon>
				</a>
			</div>
		</div>
		<div class="card-content">
			<div class="content-grid-mobile">
				<div>
					<div class="card-content-label" translate>commercial-documents.certificate-number</div>
					<a class="card-header-value"
						[routerLink]="['/commercial-documents/cards/certificate-card', document.id]">
						{{ document.name ? document.name : UNDERSCORE}}
					</a>
				</div>
				<div>
					<div class="card-content-label" translate>commercial-documents.certificate-type</div>
					<div>{{ document.subtypeDescription ? document.subtypeDescription : UNDERSCORE }}</div>
				</div>
				<div class="card-header-right">
					<mat-icon svgIcon="calendar" class="header-margin-right grey-icon"></mat-icon>
					<div class="card-container-column">
						<span class="card-content-label" translate>datacenter-filter.creation-date</span>
						<span>{{ (document.date ? document.date : UNDERSCORE) | copoDate:'date' }}</span>
					</div>
				</div>
				<div>
					<div class="card-content-label" translate>commercial-documents.mill</div>
					<div>{{ document.millDescription ? document.millDescription : UNDERSCORE }}</div>
				</div>
				<div class="card-header-double-span">
					<div class="card-container-row">
						<span class="card-content-label" translate>commercial-documents.customer-order-number</span>
						<span class="card-content-label" translate>commercial-documents.supplier-order-number</span>
						<span class="card-content-label" translate>order.steelgrade</span>
					</div>
					<div *ngFor="let docLine of document.documentLines; let i = index">
						<div class="card-container-row" *ngIf="i < 3">
							<span class="set-content">
								{{getOrderName(docLine, 'customer')}}
							</span>
							<span class="set-content">
								{{getOrderName(docLine, 'supplier')}}
							</span>
							<span class="set-content">
								{{ docLine.steelGrade ? docLine.steelGrade : UNDERSCORE}}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="card-container-column card-column-end">
			<div class="card-container-link">
				<a mat-button color="primary" (click)="callFilter(document, 'batch')"
					[routerLink]="['/order-tracking/batch/list']">
					<span translate>order.card.document.display.batches</span>
					<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
				</a>
			</div>
			<div class="card-container-link">
				<a mat-button color="primary" (click)="callFilter(document, 'order')"
					[routerLink]="['/order-tracking/order]/list']">
					<span translate>commercial-documents.display-all-orders</span>
					<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
				</a>
			</div>
		</div>
	</div>
</ng-container>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>